import { useState } from "react";
import Icon from "../Icon";
import { BtnPrimary, BtnGhost } from "../Atoms";
import { pct } from "../../utils";

export default function ExportPdfModal({project, tasks, agenda, onClose, onPreview}) {
  const projAgenda = agenda.filter(a=>String(a.project_id)===String(project?.id));
  const totalH  = projAgenda.reduce((s,a)=>s+a.hours,0);
  const completed = tasks.filter(t=>t.status==="Completada").length;
  const blocked   = tasks.filter(t=>t.status==="Bloqueada").length;
  const progress  = pct(tasks);
  return (
    <div>
      <h3 style={{margin:"0 0 16px",fontWeight:700,fontSize:16,display:"flex",alignItems:"center",gap:8}}>
        <Icon name="file-text" size={15} color="var(--accent)"/>Exportar PDF · {project?.name}
      </h3>
      <div style={{background:"var(--bg)",borderRadius:10,padding:14,marginBottom:14,border:"1px solid var(--border)"}}>
        <div style={{fontWeight:600,fontSize:12,marginBottom:8}}>El informe incluirá</div>
        {[
          ["check-circle-fill","#22c55e", tasks.length+" tareas ("+completed+" completadas, "+blocked+" bloqueadas)"],
          ["bar-chart-fill","var(--accent)","Progreso: "+progress+"%"],
          ["clock","#8b5cf6", totalH.toFixed(1)+"h registradas en el Cuaderno"],
          ["journal-text","var(--accent)", projAgenda.length+" registros del Cuaderno vinculados"],
        ].map(([ic,cl,txt])=>(
          <div key={txt} style={{display:"flex",alignItems:"center",gap:7,padding:"3px 0",fontSize:12}}>
            <Icon name={ic} size={12} color={cl}/><span>{txt}</span>
          </div>
        ))}
      </div>
      <div style={{background:"var(--info-bg)",borderRadius:9,padding:"10px 13px",marginBottom:16,border:"1px solid #bae6fd",fontSize:11.5,color:"#0369a1"}}>
        Se abrirá una vista previa completa. Usa <b>Ctrl+P</b> (⌘+P en Mac) → <b>"Guardar como PDF"</b>.
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
        <button className="btn" onClick={onClose}
          style={{padding:"8px 16px",borderRadius:9,border:"1px solid var(--border)",cursor:"pointer",fontSize:13,background:"var(--surface2)",color:"var(--text2)",fontFamily:"var(--font)"}}>
          Cerrar
        </button>
        <BtnPrimary onClick={()=>onPreview({project,tasks,agenda})}>
          <Icon name="file-text" size={13} color="#fff"/>Ver informe completo
        </BtnPrimary>
      </div>
    </div>
  );
}

